import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Report options
import ReportOptions from "components/ReportOptions/ReportOptions.jsx";
import ReportTable from "components/Table/ReportTable.jsx";

import httpr from "lib/httpRequest";
import { BASE_URL } from "lib/config";
import * as moment from "moment";
import * as json2csv from "json2csv";
import JSPdf from "jspdf";
import fileDownload from "react-file-download";

import isEmpty from "../../lib/isEmpty";

import { AuthConsumer } from "react-check-auth";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

class ReportView extends React.Component {
  constructor(props) {
    super(props);
    this._compRef = React.createRef();
    this.state = {
      tableInfo: [],
      reportDataArray: [],
      options: [],
      selectedLocIds: [],
      selectedReportType: "",
      startDate: new Date(),
      endDate: new Date(),
      DaysToNotify: [],
      MinusDays: 0,
      StartHour: new Date(),
      tableLoading: false,
      exportCsv: false,
      exportPdf: false,
      exportExcel: false
    };
  }

  componentDidMount() {
    this._isMounted = true;
    
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  focusChildComponent() {
    this._compRef.current.focus();
  }

  reportOptionButton = async options => {
    this.setState({ options });
    return;
  };

  handleExportCsv = (reportData) => {
      const { tableData, tableInfo } = reportData;
      const { tableTitle, tableSubTitle, tableType } = tableInfo;
      if (!isEmpty(tableData)) {
        // Gets column headers returned from query (may differ from displayed table)
        const fields = Object.keys(tableData[0]);
        const opts = { fields };

        const tableGeneratedAt = moment(new Date()).format(
          "MM-DD-YYYY_at_hh:mm A"
        );

        let title;
        if (tableSubTitle.length > 0) {
          title = `${tableTitle}${tableSubTitle}_${tableGeneratedAt}`;
        } else {
          title = `${tableTitle}_${tableGeneratedAt}`;
        }
        try {
          // make the header csv
          let fields = ["Report Name", "Date Created", "Date Searched For"];
          let headerFields = { fields };

          let headerBody = [
            {
              "Report Name": `${tableType.replace(/_/g, " ")}`,
              "Date Created": `${moment(new Date()).format(
                "MM-DD-YYYY hh:mm A"
              )}`,
              "Date Searched For": `${moment(
                reportData.startBusDate
              ).format("MM-DD-YYYY")} to ${moment(
                reportData.endBusDate
              ).format("MM-DD-YYYY")}`,
            },
          ];
          const header = json2csv.parse(headerBody, headerFields);

          // make the report csv
          const report = json2csv.parse(tableData, opts);

          // append to end result
          const csv = header + "\n\n" + report;

          // send result
          fileDownload(csv, `${title}.csv`);

          this.setState({ exportCsv: false });
        } catch (err) {
          console.error(err);
        }
      } else {
        // TODO: return a snackbox with error
        console.log("EMPTY");
      }
  }

  handleExportPdf = () => {
    if (this._isMounted === true){
      this.setState({
        exportPdf: !this.state.exportPdf,
      });
    }
  }

  generateReport = async options => {
    this.setState({tableLoading: true, options: options});
    const token = localStorage.getItem("token");
    const fetch = httpr(token);
    
    let reportDataArray = []; 
    if (options.selectedReportType !== ""){
    options.map((option) => {
      let reportData = {};
      reportData["isKisanReport"] = false;
      // set table info
      const tableTitle = `${option.LocationName.replace(
        /_/g,
        " "
      )} - ${option.reportName.replace(/_/g, " ")}`;
      const tableType = `${option.reportName}`;
      const tableId = `${option.LocationName}${option.report}`;
      let tableSubTitle = "";
      if (option.terminalId > -1 || option.terminalId.toString().includes("K")) {
        if (option.terminalId.toString().includes("K")){
          tableSubTitle = ` for Terminal ${option.terminalName}`;
          reportData["isKisanReport"] = true;
        } else {
          tableSubTitle = ` for Terminal ${option.terminalId}`;
        }
      };
      const tableInfo = {
        tableTitle,
        tableType,
        tableId,
        tableSubTitle
      };
      reportData["tableInfo"] = tableInfo;

      // get report
      fetch
      .post(`${BASE_URL}/api/report/generate`, { ...option })
      .then((response) => {
        reportData["tableData"] = response.data;
        reportDataArray.push(reportData); 

        if (this._isMounted === true) {
          this.setState({
            reportDataArray: reportDataArray,
            tableLoading: false
          });
        };

        // 0=generate on page, 1=exportCsv, 2=exportPdf
        if (option.exportOption) {
          if (option.exportOption === 1){
            this.handleExportCsv(reportData);
          } else if (option.exportOption === 2){
            if (reportData.tableData.length > 0){
              this.handleExportPdf();
            }
          } else {
            this.focusChildComponent();
          };
        };
      })
      .catch((error) => {
        console.log(error);
        reportData["tableData"] = [];
        reportDataArray.push(reportData);

        if (this._isMounted === true) {
          this.setState({
            reportDataArray: reportDataArray,
            tableLoading: false  
          });
        }
      });
    });
  }
    // return;
  };

  render() {
    return (
      <div>
        <AuthConsumer>
          {({ isLoading, userInfo, error }) => {
            if (isLoading) {
              return <div />;
            }

            if (!userInfo) {
              return <div />;
            }

            const { member } = userInfo;

            let Locations = [];

            if (member !== null && member !== undefined) {
              Locations = member.Locations.filter(
                location => location.OrganizationId !== 0
              );
              
              // Add license information to each location
              if (member.LocationLicenses && member.LocationLicenses.length > 0) {
                Locations = Locations.map(location => {
                  // Find license data for this location - match DashboardTabs pattern
                  const licenseData = member.LocationLicenses.find(
                    loc => loc.locationId === location.LocationId
                  );
                  
                  // Add license information to the location object
                  return {
                    ...location,
                    license: licenseData ? licenseData.license : {
                      isValid: 1, // Treat null/missing license as valid
                      daysUntilExpiration: null,
                      expirationDate: null
                    }
                  };
                });
              } else {
                // If no license data available, treat as valid license
                Locations = Locations.map(location => ({
                  ...location,
                  license: {
                    isValid: 1, // Treat missing license data as valid
                    daysUntilExpiration: null,
                    expirationDate: null
                  }
                }));
              }
            }

            return (
              <div>
                <ReportOptions
                  Locations={Locations}
                  multiple={true}
                  member={member}
                  reportOptionButton={this.reportOptionButton}
                  generateReport={this.generateReport}
                  token={userInfo.token}
                  options={this.state}
                  title={"Generate Reports"}
                  buttonTitle={"Generate"}
                  autoReport={false}
                  handleExportCsv={this.handleExportCsv}
                  handleExportPdf={this.handleExportPdf}
                  tableLoading={this.state.tableLoading}
                  exportOption={this.state.options[0] ? this.state.options[0].exportOption : 0}
                />
              </div>
            );
          }}
        </AuthConsumer>
        {this.state.reportDataArray.map((reportData, index) => {
            if (index === 0){
              return (
                <ReportTable key={index} tableHeaderColor="primary" 
                reportData={reportData}
                showLoading={this.state.tableLoading} handleExportCsv={this.handleExportCsv} handleExportPdf={this.handleExportPdf} 
                exportPdf={this.state.exportPdf}
                exportPdfComplete={this.exportPdfComplete}
                ref={this._compRef}
                />
              )
            } else {
              return (
                <ReportTable 
                key={index} 
                tableHeaderColor="primary" 
                reportData={reportData}
                showLoading={this.state.tableLoading} handleExportCsv={this.handleExportCsv} handleExportPdf={this.handleExportPdf} 
                exportPdf={this.state.exportPdf}
                exportPdfComplete={this.exportPdfComplete}
                />
              )
            }
          }
        )}
      </div>
    );
  }
}

export default withStyles(styles)(ReportView);



// WEBPACK FOOTER //
// ./src/views/Reports/Reports.jsx